import { FormControl, MenuItem, Select } from "@material-ui/core"
import PropTypes from "prop-types"
import useStyles from "./styles"

const CourseTypeFilter = ({ courseType, handleChangeCourseType }) => {
  const classes = useStyles()

  return (
    <FormControl variant="outlined" className={classes.selectContainer}>
      <Select
        value={courseType}
        onChange={handleChangeCourseType}
        labelId="demo-simple-select-outlined-label"
        id="demo-simple-select-outlined"
      >
        <MenuItem value={"all"}>All Courses</MenuItem>
        <MenuItem value={"shortcode"}>Short Codes</MenuItem>
        <MenuItem value={"course"}>Courses</MenuItem>
        <MenuItem value={"labs"}>Labs</MenuItem>
        <MenuItem value={"vaas"}>Vaas</MenuItem>
      </Select>
    </FormControl>
  )
}

CourseTypeFilter.propTypes = {
  courseType: PropTypes.string,
  handleChangeCourseType: PropTypes.func,
}
export default CourseTypeFilter
